import { Component } from '@angular/core';

@Component({
  selector: 'app-asset-transfer-entry-landing-page',
  templateUrl: './asset-transfer-entry-landing-page.component.html',
  styleUrls: ['./asset-transfer-entry-landing-page.component.scss']
})
export class AssetTransferEntryLandingPageComponent {

}
